"use client";

import { useEffect } from "react";
import { sendGA4PageView } from "../../lib/analytics/ga4";

/**
 * 404 페이지에서 GA4 page_view 이벤트를 자동으로 전송하는 컴포넌트
 * 
 * 이 컴포넌트는 not-found.tsx에서 사용됩니다.
 * 페이지가 렌더될 때 자동으로 GA4에 page_view 이벤트를 전송합니다.
 */
export function NotFoundPageView() {
  useEffect(() => {
    // 페이지가 마운트될 때 GA4 page_view 전송
    const sendPageView = async () => {
      if (typeof window === "undefined") return;

      const pageLocation = window.location.href;
      const pagePath = window.location.pathname + window.location.search;
      const pageReferrer = document.referrer || undefined;

      await sendGA4PageView({
        pageLocation,
        pagePath,
        pageTitle: "404",
        pageReferrer,
      });
    };

    // 약간의 지연을 두어 GA4 스크립트가 완전히 로드되도록 함
    // 하지만 waitForGA4 함수가 이미 대기하므로 즉시 호출해도 됨
    sendPageView();
  }, []);

  // 이 컴포넌트는 UI를 렌더링하지 않음
  return null;
}

